export enum ProposalMetricDeltaCalculation {
	DIFFERENCE = 'DIFFERENCE',
	PERCENTAGE = 'PERCENTAGE'
}
